module.exports = __webpack_public_path__ + "01_glasses_blue.3dfe5738.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/01_glasses_blue.png
// module id = foZb
// module chunks = 0